/**
 * Drop affordance shown over the prompt bar while a file is dragged across
 * it. Presentational only — the target-scoped listeners in
 * useImagePasteAndDrop handle the drop itself. It must be rendered inside the
 * prompt bar container (position: relative) and keeps pointer events enabled
 * so it is the topmost drop target: drops land on it (and bubble to the
 * container) instead of reaching the editor underneath.
 */
export const AddImageOverlay = () => {
	return (
		<div
			data-testid="add-image-overlay"
			className="border-beacon-accent absolute inset-0 z-10 flex items-center
				justify-center rounded-2xl border-2 border-dashed bg-white/90
				backdrop-blur-sm"
		>
			<span className="text-beacon-accent text-sm font-medium">
				Drop a jpg or png file to add it to the conversation
			</span>
		</div>
	);
};
